import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-8" }
const _hoisted_2 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_3 = {
  key: 0,
  class: "mt-8"
}
const _hoisted_4 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _createElementVNode("span", {
        class: _normalizeClass({ required: _ctx.input.conditionalRequired ? _ctx.input.conditionalRequired(_ctx.id) : _ctx.input.required })
      }, _toDisplayString(_ctx.input.label), 3)
    ]),
    _createVNode(_component_Field, {
      class: "form-control form-control-solid",
      type: "password",
      name: _ctx.input.name,
      ref: _ctx.input.name,
      modelValue: _ctx.model,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model) = $event)),
      placeholder: _ctx.input.name,
      autocomplete: "chrome-off",
      onChange: _ctx.onChange
    }, null, 8, ["name", "modelValue", "placeholder", "onChange"]),
    _createVNode(_component_ErrorMessage, {
      name: _ctx.input.name
    }, null, 8, ["name"]),
    (_ctx.input.hasConfirmationField)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, [
            _createElementVNode("span", {
              class: _normalizeClass({ required: _ctx.input.conditionalRequired ? _ctx.input.conditionalRequired(_ctx.id) : _ctx.input.required })
            }, _toDisplayString(_ctx.input.confirmationFieldLabel), 3)
          ]),
          _createVNode(_component_Field, {
            class: "form-control form-control-solid",
            type: "password",
            ref: _ctx.input.confirmationField,
            name: _ctx.input.confirmationField,
            placeholder: _ctx.input.confirmationField,
            autocomplete: "chrome-off"
          }, null, 8, ["name", "placeholder"]),
          _createVNode(_component_ErrorMessage, {
            name: _ctx.input.confirmationField
          }, null, 8, ["name"])
        ]))
      : _createCommentVNode("", true)
  ]))
}